import useSideBarContent from '@modules/ui/shared/hooks/useSideBarContent';
import React, { useEffect } from 'react';

function AppLeftNav({ children }: { children: React.ReactElement }) {
  const { setHasLeftNav } = useSideBarContent();
  useEffect(() => {
    setHasLeftNav(true);
    return () => {
      setHasLeftNav(false);
    };
  }, [setHasLeftNav]);
  return children;
}

AppLeftNav.displayName = 'AppLeftNav';

export default AppLeftNav;
